'use client'

import CountryDropdown from '@/components/comman/CountryDropdown'
import { OTHER_COUNTRY } from '@/constants/constants'
import useIsMobile from '@/hooks/useIsMobile'
import { Country } from '@/types/types'
import { cn, Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'
import { FooterProps, MenuItemProps, MenuSectionsType } from '../schema'

const CjrFooter = ({ data }: { data: FooterProps }) => {
  const router = useRouter()
  const {
    logo,
    subHeading,
    topLinks,
    bottomLinks,
    menuSectionsHeading,
    menuSections,
    boyImage = '',
    boyBgImage = '',
    countryDropdownVisible = true,
  } = data

  const { isMobile } = useIsMobile()

  const pathname = usePathname()

  const handleCountrySelect = (country: Country, isPageGlobal: boolean) => {
    const pathnameExceptFirst = pathname?.split?.('/').slice(2).join('/')
    // selecting global country from dropdown
    if (country?._id === OTHER_COUNTRY._id) {
      if (isPageGlobal) {
        return
      }
      if (typeof window !== 'undefined') {
        window.location.href = `/${pathnameExceptFirst}${window.location.search}`
      }
    }
    // selecting country from dropdown
    else if (typeof window !== 'undefined') {
      if (isPageGlobal) {
        if (typeof window !== 'undefined') {
          window.location.href = `/${country?.countryGroup?.toLowerCase()}${pathname}${window.location.search}`
          return
        }
      }
      if (typeof window !== 'undefined') {
        window.location.href = `/${country?.countryGroup?.toLowerCase()}/${pathnameExceptFirst}${window.location.search}`
      }
    }
  }

  const handleFooterClick = (val: MenuItemProps) => {
    if (typeof window !== 'undefined') {
      const newWindow = window.open(val?.href, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <div className="w-full py-8 md:py-16 text-body-grey-50 overflow-hidden relative" style={{background: 'linear-gradient(95.39deg, var(--static-color-black) 0%, #6b2e04 114.26%)'}}>
      <div className="flex flex-col max-w-6xl mx-auto px-4 md:px-6 relative">
        <div className="flex flex-col gap-6 md:gap-8 md:max-w-3xl z-[1]">
          <div className="flex flex-col gap-3">
            <div className="relative w-[177px] h-[48px]">
              <Image src={logo} alt='Logo' layout='fill' objectFit='cover' loading='lazy' />
            </div>
            <Typography variant='small' className="mb-[-2px]" color='#e4e7ea'>
              {subHeading}
            </Typography>
          </div>

          <div className="flex md:flex-row md:justify-between flex-col gap-4 md:gap-0">
            <div className="flex flex-col gap-2">
              <Typography variant='heading3' weight={isMobile ? 'semi-bold' : 'bold'} color='#E4E7EA'>
                More About Us
              </Typography>
              <div className="grid grid-cols-2 md:max-w-md md:gap-3 gap-2.5">
                {topLinks?.map(({ title, url, isOpenInNewTab = false }) => (
                  <div className="md:w-52" key={title}>
                    <a
                      target={isOpenInNewTab ? '_blank' : '_self'}
                      href={url}
                      className="hover:underline"
                      rel='noreferrer'
                    >
                      <Typography variant='small' color='#e4e7ea'>
                        {title}
                      </Typography>
                    </a>
                  </div>
                ))}
              </div>
            </div>

            {countryDropdownVisible && !isMobile && (
              <div className="flex flex-col gap-2.5 md:flex w-[245px] md:w-auto">
                <Typography variant='heading3' weight={isMobile ? 'semi-bold' : 'bold'} color='#E4E7EA'>
                  Country
                </Typography>
                <div id='country-dropdown-footer-cjr'>
                  <CountryDropdown handleSelectedCountry={handleCountrySelect} cameFrom='footer' />
                </div>
              </div>
            )}
          </div>
          {menuSections && <div className="border-t border-t-[#3D3D3D] mt-4 sm:mt-6" style={{position:'relative',left:'50%',right:'50%',marginLeft:'-50vw',marginRight:'-50vw'}}></div>}

          {menuSectionsHeading && (
            <Typography
              variant='heading4'
              className="mb-[-20px]"
              color='#E4E7EA'
              weight='semi-bold'
            >
              {menuSectionsHeading}
            </Typography>
          )}
          {menuSections && (
            <div className='xl:w-[85%] grid xl:grid-cols-3 gap-5 md:grid-cols-3 md:place-items-start grid-cols-2 md:pt-6 xl:pt-0'>
              {menuSections?.map((menuItems: MenuSectionsType) => {
                return (
                  <div key={menuItems?.label}>
                    <div className='mb-2 text-start'>
                      <Typography color='#E4E7EA' weight='bold' variant='regular'>
                        {menuItems?.label}
                      </Typography>
                    </div>
                    <div className='flex flex-col text-start gap-2'>
                      {menuItems?.items?.map((val: MenuItemProps) => {
                        return (
                          <a
                            href={val?.href}
                            key={val?.label}
                            onClick={e => {
                              e.preventDefault()
                              handleFooterClick(val)
                            }}
                          >
                            <Typography
                              color='#E4E7EA'
                              variant='small'
                              className='hover:underline cursor-pointer'
                            >
                              {val?.label}
                            </Typography>
                          </a>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          )}

          {countryDropdownVisible && isMobile && (
            <div className="flex flex-col gap-2.5 md:flex w-[245px] md:w-auto mb-[10px]">
              <Typography variant='heading3' weight={isMobile ? 'semi-bold' : 'bold'}>
                Country
              </Typography>
              <div id='country-dropdown-footer-cjr'>
                <CountryDropdown handleSelectedCountry={handleCountrySelect} cameFrom='footer' />
              </div>
            </div>
          )}
        </div>
        <div className={isMobile ? "border-t border-t-[#D9DCE1] flex flex-col md:flex-row justify-between pt-2 md:pt-4 gap-2 md:gap-0 max-w-[137px] md:max-w-none mt-[24px]" : "border-t border-t-[#D9DCE1] flex flex-col md:flex-row justify-between pt-2 md:pt-4 gap-2 md:gap-0 w-full mt-[32px]"}>
          <div className="flex flex-col md:flex-row gap-3">
            {bottomLinks?.map(({ title, url }, ind: number) => (
              <React.Fragment key={title}>
                {ind !== 0 && (
                  <Typography component='span' className="hidden md:block" color='#e4e7ea' variant='small'>
                    |
                  </Typography>
                )}
                <a href={url} className="hover:underline">
                  <Typography variant='small' color='#e4e7ea'>
                    {title}
                  </Typography>
                </a>
              </React.Fragment>
            ))}
          </div>
            <div className="pt-2 md:pt-0 md:border-none border-t border-t-[#D9DCE1] max-w-[200px] md:max-w-none">
            <Typography component='span' variant='small' className="block md:inline max-w-[110px] md:max-w-none" color='#e4e7ea'>
              {data?.copyrightText}
            </Typography>
          </div>
        </div>
      </div>

      {boyBgImage && (
        <div
          className={cn("absolute w-[306px] h-[249px] lg:w-96 lg:h-80 mx-auto right-[-130px] lg:right-0", {
            ['-bottom-4']: isMobile,
            ['top-[50px]']: !isMobile,
          })}
        >
          <Image src={boyBgImage} layout='fill' alt='Boy Illustration Footer' loading='lazy' />
        </div>
      )}
      {boyImage && (
        <div
          className={cn("absolute w-[153px] h-[160px] right-1.5 lg:w-72 lg:h-72 mx-auto lg:right-10", {
            ['bottom-[-15px] lg:bottom-4']: isMobile,
            ['top-[50px]']: !isMobile,
          })}
        >
          <Image src={boyImage} layout='fill' alt='Boy Illustration Footer' loading='lazy' />
        </div>
      )}
    </div>
  )
}

export default CjrFooter
